import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import {
  ArrayTagChip,
  CustomTable,
  Page,
  PrimaryButton,
  SecondaryButton,
  SectionLabel,
  SongUsageTrendChart,
} from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { HeaderTitle } from "layouts";
import { useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { globalStyles } from "styles";
import {
  columnTableDashboard,
  columnTableInvoice,
} from "../components/ConstantDashboardComposer";
import InformationCard from "../components/InformationCard";

const PrintReportDashboard = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { state } = useLocation();
  const inputRef = useRef(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const {
    dashboardSummary,
    chartData,
    queryParams,
    selectedDSP,
    userName,
    dashboardInformation,
    dataTableDashboard,
    dataTableInvoice,
  } = state;

  const generatePdf = async () => {
    const element = inputRef.current;

    await document.fonts.ready;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pageWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
    pdf.save(`Review Dashboard${userName ? ` ${userName}` : ""}.pdf`);
  };

  const handlePrintPDF = async () => {
    setLoadingButton(true);
    await generatePdf();
    setLoadingButton(false);
  };

  return (
    <Page className={classes.root} title="Review Dashboard">
      <Container
        maxWidth={false}
        className={classes.printRoot}
        id="content-to-print"
        ref={inputRef}
      >
        <HeaderTitle
          title={`Review Dashboard ${userName ? ` | ${userName}` : ""}`}
        />
        <Divider className={classes.divider} />
        <Grid container>
          <InformationCard
            title="Total Balance"
            value={dashboardSummary?.balance_number}
            buttonLabel="View Revenue Information"
            prefix="Rp"
            length={2}
          />
          <InformationCard
            title="Paid Amount"
            value={dashboardSummary?.paid_amount}
            prefix="Rp"
            length={2}
          />
        </Grid>
        <Box
          border="1px solid #ebebeb"
          borderRadius="5px"
          padding="50px 20px"
          my="24px"
        >
          {chartData?.datasets?.length > 0 && queryParams?.dsp_ids && (
            <ArrayTagChip
              selectionsList={
                selectedDSP.some(item => item.dsp_id === "all")
                  ? [{ dsp_id: "all", name: "All" }]
                  : selectedDSP
              }
              value="name"
            />
          )}
          <Box
            width="100%"
            mt={2}
            className={`${classes.chartWrapper} print-chart`}
          >
            <SongUsageTrendChart chartData={chartData} />
          </Box>
        </Box>
        <Grid container my="16px">
          <InformationCard
            title="Total Songs"
            value={dashboardInformation?.songs}
            length={3}
          />
          <InformationCard
            title="Total Listener Traffic"
            value={dashboardInformation?.traffic}
            length={3}
          />
          <InformationCard
            title="Total Revenue"
            value={dashboardInformation?.revenue}
            prefix="Rp"
            length={3}
          />
        </Grid>
        <CustomTable
          columnTable={columnTableDashboard(true)}
          data={dataTableDashboard || []}
        />
        <SectionLabel title="Payment Claim" my="16px" />
        <CustomTable
          columnTable={columnTableInvoice(true)}
          data={dataTableInvoice || []}
        />
      </Container>
      <Box justifyContent="flex-end" display="flex" gap={1} m={3}>
        <SecondaryButton label="Back" onClick={() => history.goBack()} />
        <PrimaryButton
          label={loadingButton ? "Please Wait ..." : "Print Report"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handlePrintPDF}
        />
      </Box>
    </Page>
  );
};

export default PrintReportDashboard;
